import { render } from "./ComponentSecondaryInfo.vue?vue&type=template&id=41b52da0"
const script = {}

import exportComponent from "/Users/alsadi/vuemasterclass/vue-masterclass-vuecli/node_modules/.pnpm/vue-loader@17.0.1_vue@3.2.45+webpack@5.75.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__